JSON.tryParse = function <T>(value: string, defaultValue: T | null = null): T {
	if (value && value != 'undefined') {
		try {
			return JSON.parse(value) as T;
		} catch (e) {
			return defaultValue !== null ? defaultValue : null;
		}
	}
	return defaultValue !== null ? defaultValue : null;
};

export {};
